export default __webpack_public_path__ + "static/media/2378.af3fe244.png";